import C from './components';

export default C;
